import types from './actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case types.OPEN_COLLAPSE:
    case types.CLOSE_COLLAPSE:
    case types.INITIALIZE_COLLAPSE:
      return { ...state, [action.name]: action.isOpened }
    case types.REMOVE_COLLAPSE:
      const { [action.name]: collapse, ...withoutCollapse } = state
      return withoutCollapse
    default:
      return state
  }
}
